import React, { useState } from "react";

const Questionx = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div
      className="faq-section animated"
      onMouseEnter={toggleAccordion}
      onMouseLeave={toggleAccordion}
    >
      <div
        className={`faq-header ${isOpen ? "open" : ""}`}
        onClick={toggleAccordion}
      >
        <div className="faq-question">
          What happens if I'm not satisfied with the virtual assistant's
          performance?
        </div>
        {/* <div
          className="faq-icon"
          style={{ fontSize: "40px", paddingRight: "20px" }}
        >
          {isOpen ? "-" : "+"}
          <FontAwesomeIcon icon="fa-circle-question" color="black" />
        </div> */}
      </div>
      {isOpen && (
        <div className="faq-answer">
          <span>
            We acknowledge that there may be a need to seek a more suitable
            virtual assistant, and we fully support this endeavor. We are
            committed to accommodating your request and diligently facilitating
            the transition to a more fitting virtual assistant, ensuring a
            smooth transfer of work responsibilities and ensuring that the
            requisite skills and knowledge are readily available for the tasks
            at hand.
          </span>
        </div>
      )}
    </div>
  );
};

export default Questionx;
